import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem('cookie-consent', 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 border-t-2 border-primary bg-background shadow-lg">
      <div className="flex flex-col items-center gap-2 px-4 py-3 sm:flex-row sm:gap-8 sm:px-8">
        {/* Mobile : texte court */}
        <p className="block sm:hidden text-xs text-muted-foreground text-center">
          Ce site utilise des cookies.{' '}
          <Link to="/politique-de-confidentialite" className="text-primary underline hover:text-primary/80">
            En savoir plus
          </Link>
        </p>
        {/* Desktop : texte détaillé */}
        <p className="hidden sm:block text-sm text-muted-foreground text-center flex-1">
          Ce site utilise des cookies pour améliorer votre expérience de navigation. En continuant, vous acceptez notre{' '}
          <Link to="/politique-de-confidentialite" className="text-primary underline hover:text-primary/80">
            politique de confidentialité
          </Link>.
        </p>
        <div className="flex shrink-0 gap-3">
          <Button variant="outline" className="h-9 px-5 text-sm rounded-md" onClick={refuse}>
            Refuser
          </Button>
          <Button className="h-9 px-5 text-sm rounded-md" onClick={accept}>
            Accepter
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
